import find from "lodash/find";

export default function findOverlappingBufferSegment(buffer, time) {
  return find(
    buffer,
    (bufferSegment) => time >= bufferSegment.start && time <= bufferSegment.end,
  );
}
